// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"296a165a","106":"ce8ba188","268":"375ac2af","370":"dd41182a","563":"40c432a0","650":"80aada64","692":"eebbfbf8","763":"c2157b26","806":"9ab2d006","887":"20bcd289","949":"620101e7"}[chunkId] + ".chunk.js";
};